import Api from '../api';

export const conlicitaGo = async () => {
  const response = await Api.get('/facilitadores/token_express');

  return response;
};
